import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

export type PageLayoutProps = HTMLAttributes<HTMLDivElement>;

export const PageLayout = ({ children, ...props }: PageLayoutProps) => {
	const classes = classNames('page-layout', props.className);
	return (
		<div {...props} className={classes}>
			{children}
		</div>
	);
};

export default PageLayout;
